// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const memberApprovalPolicySchema = z.object({
  "version": z.number().int().min(0),
  "enabled": z.boolean(),
  "reviewer_admin_ids": z.array(z.string().uuid()).max(20)
});

export const memberRequestSchema = z.object({
  "id": z.string().uuid(),
  "user_id": z.string().uuid(),
  "email": z.string(),
  "display_name": z.string(),
  "status": z.enum(["pending", "approved", "rejected", "cancelled", "revoked"]),
  "requested_at": z.string().datetime({ offset: true }),
  "decided_at": z.string().datetime({ offset: true }).nullable(),
  "decided_by": z.string().uuid().nullable(),
  "decision_note": z.string().max(500),
  "revoked_at": z.string().datetime({ offset: true }).nullable(),
  "revoked_by": z.string().uuid().nullable(),
  "revocation_note": z.string().max(500)
});

export const memberReviewersSchema = z.object({
  "items": z.array(z.object({
    "id": z.string().uuid(),
    "name": z.string(),
    "email": z.string()
  }))
});

export const memberDeskRequestSchema = z.object({
  "id": z.string().uuid(),
  "user_id": z.string().uuid(),
  "email": z.string(),
  "display_name": z.string(),
  "status": z.enum(["pending", "approved", "rejected", "cancelled", "revoked"]),
  "requested_at": z.string().datetime({ offset: true }),
  "decided_at": z.string().datetime({ offset: true }).nullable(),
  "decided_by": z.string().uuid().nullable(),
  "decision_note": z.string().max(500),
  "revoked_at": z.string().datetime({ offset: true }).nullable(),
  "revoked_by": z.string().uuid().nullable(),
  "revocation_note": z.string().max(500),
  "organization_id": z.string().uuid(),
  "organization_name": z.string(),
  "approval_enabled": z.boolean(),
  "decided_by_name": z.string().optional(),
  "decided_by_email": z.string().optional(),
  "revoked_by_name": z.string().optional(),
  "revoked_by_email": z.string().optional()
});

export const memberDeskResponseSchema = z.object({
  "items": z.array(memberDeskRequestSchema),
  "next_cursor": z.string().uuid().nullable()
});
